module.exports = __webpack_public_path__ + "img/iconmonstr-linkedin-3.91ff05d4.svg";